export default __webpack_public_path__ + "static/media/5_3.43b9d70d.jpg";